/* eslint-disable react/no-array-index-key */
import React, { memo } from 'react';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import { getLocaleResourceCode } from '$/store/languageStore/locale';
import { mtstatTrack } from '$/utils/mtstat';
import type { ProductOperationList } from '..';
import styles from './index.module.scss';

/**
 * 展示共用的使用手册、视频教程入口及服务端活动列表。
 */
function OverlayContent(props: { hide: () => void; list: ProductOperationList; }) {
  const { hide, list = [] } = props;
  const languageStore = useLanguageStore((state) => state.languageStore);

  /** 关闭入口菜单，并按当前语言在新标签页打开对应的视频教程。 */
  const openTutorials = () => {
    hide();
    const languageCode = getLocaleResourceCode(languageStore.languageCode);
    const tutorialLanguage = languageCode === 'kor' ? 'ko' : languageCode;
    const tutorialPath = tutorialLanguage === 'en' ? '/tutorials' : `/${tutorialLanguage}/tutorials`;
    window.open(tutorialPath, '_blank');
  };

  return (
    <div className={styles['overlay-container']}>
      <div
        onClick={() => {
          hide();
          mtstatTrack('roboneo_top_guide_click', {
            type: 'used_book',
          });
          const language = languageStore.languageCode;
          if (language === 'pt') {
            window.open('https://meitu.feishu.cn/wiki/OBguwRQB1isvNKkqSFScXE2fn2b');
          } else if (language === 'zh' || language === 'zh-Hans' || language === 'zh-Hant') {
            window.open('https://meitu.feishu.cn/wiki/HMD3wc9GriGvNzk3j0Rc8fnpndb');
          } else {
            window.open('https://meitu.feishu.cn/wiki/Lo5aw4onCixmQTkkXmycy8NQn4c');
          }
        }}
        className={styles['product-book']}
      >
        <IconFont
          name="bookBold"
          fontSize={16}
          style={{ marginRight: '4px' }}
        />
        <div>
          {languageStore.smartcatTranslationText(
            (v) => v.RoboNeo_Web_Product_User_Manual,
          )}
        </div>
      </div>
      <div
        onClick={openTutorials}
        className={styles['product-book']}
      >
        <IconFont
          name="kolAcademyBold"
          fontSize={16}
          style={{ marginRight: '4px' }}
        />
        <div>
          {languageStore.smartcatTranslationText((v) => v.tutorial)}
        </div>
      </div>
      {!!list?.length && <div className={styles.spliter} />}
      <div className={styles['list-container']}>
        {(list || []).map((item, index) => (
          <div
            key={index}
            className={styles['activity-item']}
            onClick={() => {
              mtstatTrack('roboneo_top_guide_click', {
                type: 'activity',
                activity_id: item.id,

              });
              window.open(item.activity_link);
              hide?.();
            }}
          >
            <div>
              {item?.activity_name}
            </div>
            <IconFont
              name="chevronRightFill"
              fontSize={16}
              color="var(--content-tertiary)"
            />
          </div>
        ))}
      </div>

    </div>
  );
}
export default memo(OverlayContent);
